<template>
    <div class="moduleAppSchool">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <location-selector hasProvinceAll hasCityAll @change="getUsedSchoolsFunc()" v-model="locationArray"></location-selector>
            <el-select size="medium" @change="getUsedSchoolsFunc()" v-model="type" placeholder="请选择">
                <el-option :key="0" label="全部类型" :value="0"></el-option>
                <el-option v-for="[value, label] in schoolTypeConstants" :key="value" :label="label"
                           :value="value"></el-option>
            </el-select>
            <a
                :href="downLoadHref"
                target="_blank"
                download="activityName"
            >
                <el-button
                    type="primary"
                    size="medium"
                >导出</el-button>
            </a>
            <el-input size="medium" class="search-input search-input--right" placeholder="学校名称"
                      v-model="schoolname" @keyup.enter.native="getUsedSchoolsFunc">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="getUsedSchoolsFunc"></el-button>
            </el-input>
        </div>
        <div>
            <el-table
                :height="windowHeight - 200"
                :data="schoolList" border
                style="width: 100%"
            >
                <el-table-column
                    label="id"
                    prop="id"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="学校名称"
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="类型"
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{parseToConstants(scope.row.type, 'schoolTypeConstants')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="区域"
                    prop="orgAreaName"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="客户端类型"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{({
                        1: '企业微信',
                        2: '农行',
                        12: '企业微信及农行',
                        3: '建行生活',
                        4: '建行APP'
                        }[scope.row.clientType])}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="责任人"
                    align="center"
                    prop="liableNames"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="uninstallFunc(scope.row)">卸载</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import LocationSelector from '@/components/LocationSelector';
    import BackTool from '@/components/BackTool';
    import windowResize from '@/mixins/windowResize.js';
    import {schoolTypeConstants} from '@/utils/constants';

    import {getExportUrl, parseToConstants} from '@/utils/utils';
    import {
        getUsedSchools,
        updateUninstallModule
    } from '@/api/moduleApp';

    export default {
        name: "moduleAppSchool",
        components: {BackTool, LocationSelector},
        mixins: [windowResize],
        computed: {
            exportUrl() {
                return getExportUrl('module/exportUsedSchools', {
                    postcode: this.postcode,
                    moduleId: this.id
                });
            },
            downLoadHref() {
                return getExportUrl('wyms/module/exportUsedSchools', {
                    areaCode: this.getAreaCode(),
                    bussinessNumber: '',
                    moduleId: this.id,
                    schoolname: this.schoolname,
                    type: this.type
                }, global.command === "production" ? `https://wyms.weixiaojia.cn/` : `https://wyms.weixiaojia.net/`);
            },
        },
        data() {
            return {
                schoolTypeConstants,
                id: this.$route.query.id,
                locationArray: ['320000', '320100', '0'],
                postcode: '',
                postList: [],
                schoolList: [],
                type: 0,
                schoolname: ''
            }
        },

        created() {
            this.getUsedSchoolsFunc();
        },
        methods: {
            parseToConstants,
            uninstallFunc(school) {
                this.$confirm('确认要卸载吗？', '卸载', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    updateUninstallModule({
                        moduleId: this.id,
                        schoolId: school.id
                    })
                        .then(() => {
                            this.$message.success('卸载完成');
                            this.getUsedSchoolsFunc();
                        })
                });
            },
            getUsedSchoolsFunc() {
                setTimeout(() => {
                    getUsedSchools({
                        areaCode: this.getAreaCode(),
                        bussinessNumber: '',
                        schoolname: this.schoolname,
                        type: this.type,
                        moduleId: this.id,
                    })
                        .then(data => {
                            this.schoolList = data;
                        });

                }, 200);

            },
            getAreaCode() {
                return this.locationArray[2] == '0' ? (this.locationArray[1] == '0' ? (this.locationArray[0] == '0' ? '' : this.locationArray[0].slice(0, 2)) : this.locationArray[1].slice(0, 4)) : this.locationArray[2];
            }
        }
    }
</script>
<style>
    .moduleAppSchool .el-select {
        width: 120px;
    }
</style>
<style lang="scss" scoped>
    @import "../../../styles/mixin";

    .moduleAppSchool {
        padding: 12px;

        .top {
            padding-bottom: 10px;
        }

    }

    .school-item {
        display: flex;
        float: left;
        align-items: center;
        width: 202px;
        height: 80px;
        margin: 10px;
        padding: 6px 10px;
        overflow: hidden;
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
        transition: all .3s linear;

        .school-item__photo {
            @include cover-bg;
            width: 50px;
            height: 50px;
            margin: 10px 5px;
            margin-right: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/moduleApp/moduleAppSchool.vue